import type { Dispatch } from '@avalara/types/actions';
import type { Result } from '@avalara/types/index';
import type { ProductClientDetails } from '@avalara/types/product-detail';

import conf from '../../conf';
import { setProductDetail } from '../../store/product-detail';
import fetch from '../fetch';
import { getWindowQueryUnlessInProd } from '../helpers';
import { getSystemErrorMessaging } from './error';

export const fetchProductDetail = (productKey: string) => async (dispatch: Dispatch) => {
  // Forwards the page's own query string (non-prod only, e.g. ?useMockObligations) so a dev/QA
  // override actually reaches the server -- same pattern as
  // offer-flow.ts/offers.ts/accounts.ts/economic-nexus.ts.
  const query = getWindowQueryUnlessInProd();
  const result: Result<ProductClientDetails> = await fetch(dispatch)(
    `${conf.API_URL}/api/products/${productKey}${query}`,
  );

  if (result.ok) {
    dispatch(setProductDetail(result.value));
    // A checkCrossSellEligibility lookup failure (BRGUI-2724) is a 200 with
    // eligibilityCheckFailed: true, not a fetch failure -- show the same generic error dialog a
    // real fetch failure would, rather than silently rendering as if this viewer were eligible.
    if (result.value.eligibilityCheckFailed) {
      dispatch(getSystemErrorMessaging({ errorCode: 'genericError' }));
    }
  } else if (result.status === 404) {
    dispatch(setProductDetail('NOT_FOUND'));
  } else {
    dispatch(setProductDetail('ERROR'));
    dispatch(getSystemErrorMessaging({ errorCode: 'genericError' }));
  }
};
